import { FilterItem, FilterStuff } from "@/views/loyalty/shared/classes/filter_stuff"

export class FilterService {
    constructor (model) {
        this.model = model
    }

    fillFilterStuff (ObjTitlesModel) {
        const filterStuff = new FilterStuff()
        ObjTitlesModel.forEach(item => filterStuff.add(new FilterItem().fieldKey(item.value).fieldName(item.text).fieldValue("").fieldType(item.filterType).fieldValues(item.filterValues).fieldMoney().fieldDate().fieldTitle("").value))
        // this.filterStuff = this.filterStuff.items
        console.log('filterStuff', filterStuff)
        return filterStuff.items
    }

    getFilterStuff (filterStuff) {
        return filterStuff.filter(f => f.fieldValue.toString().length > 0 || Object.keys(f.fieldDate).length > 0 || Object.keys(f.fieldMoney).length > 0)
            .map(fs => Object.fromEntries(Object.entries(fs).filter(([key]) => [
                'fieldValue', 'fieldDate', 'fieldMoney', 'fieldType', 'fieldKey'].includes(key)
            )))
    }
}
